import { Check } from "lucide-react";

export const fmtPrice = (n) => `${Number(n).toLocaleString("it-IT", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} €`;

export const PlanPicker = ({ plans, value, onChange, error }) => (
  <div>
    <div className="grid gap-4 md:grid-cols-3" role="radiogroup">
      {plans.map((p) => {
        const on = value === p.plan_id;
        return (
          <button
            key={p.plan_id}
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => onChange(p.plan_id)}
            className={`rounded-2xl border-2 p-5 text-left transition-[border-color,background-color,transform] duration-200 hover:-translate-y-0.5 ${on ? "border-[#0F2D5E] bg-[#0F2D5E] text-white" : "border-[#E2E5DC] bg-white"}`}
            data-testid={`plan-option-${p.plan_id}`}
          >
            <div className="flex items-center justify-between">
              <span className="text-lg font-extrabold">{p.name}</span>
              {on && <Check className="h-5 w-5 text-[#F4C20D]" />}
            </div>
            <p className="mt-2 text-2xl font-extrabold">{fmtPrice(p.price_month)}<span className={`text-sm font-medium ${on ? "text-white/70" : "text-[#75867E]"}`}> /mese + IVA</span></p>
            <p className={`mt-2 text-sm ${on ? "text-white/85" : "text-[#495850]"}`}>{p.description}</p>
            <ul className="mt-3 space-y-1 text-sm">
              {p.features.map((f) => <li key={f} className="flex gap-2"><Check className={`mt-0.5 h-4 w-4 shrink-0 ${on ? "text-[#F4C20D]" : "text-[#0F2D5E]"}`} />{f}</li>)}
            </ul>
          </button>
        );
      })}
    </div>
    {error && <p className="mt-2 text-xs text-red-600" data-testid="plan-error">{error}</p>}
  </div>
);
